import {
    useState,
} from 'react';

import {
    IMAGE_URL,
} from '../../../path';

type Props = {
    cuisine?: any;
    onClose: () => void;
    onSave: (
        data: FormData
    ) => void;
};

export default function CuisineModal({
                                         cuisine,
                                         onClose,
                                         onSave,
                                     }: Props)
{
    const [name, setName] =
        useState(
            cuisine?.name || ''
        );

    const [
        shortDescription,
        setShortDescription
    ] = useState(
        cuisine?.short_description || ''
    );

    const [
        coverImage,
        setCoverImage
    ] = useState<File | null>(
        null
    );

    const [
        coverPreview,
        setCoverPreview
    ] = useState(
        cuisine?.cover_image || ''
    );

    const [
        isActive,
        setIsActive
    ] = useState(
        cuisine?.is_active ?? true
    );

    const getImageUrl = (
        path?: string
    ) => {

        if (!path) {
            return '';
        }

        if (
            path.startsWith(
                'http'
            ) ||
            path.startsWith(
                'blob:'
            )
        ) {

            return path;
        }

        return `${IMAGE_URL}${path}`;
    };

    const handleSubmit = (
        e: React.FormEvent
    ) => {

        e.preventDefault();

        const formData =
            new FormData();

        formData.append(
            'name',
            name
        );

        formData.append(
            'short_description',
            shortDescription
        );

        formData.append(
            'is_active',
            isActive
                ? '1'
                : '0'
        );

        if (
            coverImage
        ) {

            formData.append(
                'cover_image',
                coverImage
            );
        }

        onSave(
            formData
        );
    };

    return (

        <div
            className="modal-overlay"
            onClick={onClose}
        >

            <div
                className="modal-box"
                onClick={(e) => e.stopPropagation()}
            >

                <h2>

                    {cuisine
                        ? 'Edit Cuisine'
                        : 'Add Cuisine'}

                </h2>

                <form
                    className="modal-form"
                    onSubmit={
                        handleSubmit
                    }
                >

                    <label>
                        Name
                    </label>

                    <input
                        type="text"
                        value={name}
                        onChange={(e) =>
                            setName(
                                e.target.value
                            )
                        }
                        required
                    />

                    <label>
                        Cover Image
                    </label>

                    {coverPreview && (

                        <img
                            src={
                                getImageUrl(
                                    coverPreview
                                )
                            }
                            alt=""
                            className="image-preview"
                        />

                    )}

                    <p className="field-hint">
                        Maximum file size: 2MB
                    </p>

                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {

                            const file =
                                e.target.files?.[0];

                            if (!file) {
                                return;
                            }

                            if (
                                file.size >
                                2 * 1024 * 1024
                            ) {

                                alert(
                                    'Image must be 2MB or smaller.'
                                );

                                return;
                            }

                            setCoverImage(
                                file
                            );

                            setCoverPreview(
                                URL.createObjectURL(
                                    file
                                )
                            );

                        }}
                    />

                    <label>
                        Short Description
                    </label>

                    <textarea
                        rows={5}
                        value={
                            shortDescription
                        }
                        onChange={(e) =>
                            setShortDescription(
                                e.target.value
                            )
                        }
                    />

                    <label>
                        Active
                    </label>

                    <select
                        value={
                            isActive
                                ? '1'
                                : '0'
                        }
                        onChange={(e) =>
                            setIsActive(
                                e.target.value ===
                                '1'
                            )
                        }
                    >

                        <option value="1">
                            Yes
                        </option>

                        <option value="0">
                            No
                        </option>

                    </select>

                    <div className="modal-actions">

                        <div className="left-actions">

                            <button
                                type="button"
                                className="cancel-btn"
                                onClick={
                                    onClose
                                }
                            >
                                Cancel
                            </button>

                        </div>

                        <div className="right-actions">

                            <button
                                type="submit"
                                className="action-btn"
                            >
                                Save
                            </button>

                        </div>

                    </div>

                </form>

            </div>

        </div>

    );
}
